export default __webpack_public_path__ + "img/Thur.e3943285.png";